import { Footer } from '../homepage/Footer';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { StatusMessages } from './StatusPage.messages';
import { CommonMessages } from '../../i18n/Common.messages';
import { PageSeo } from '../seo/PageSeo';
import { breadcrumbSchema } from '../seo/schemas';
import './static-page.css';

export const StatusPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
    <PageSeo
      path="/status"
      localized
      titleKey="seo.status.title"
      descriptionKey="seo.status.description"
      ogImage="/og/og-default.png"
      jsonLd={[breadcrumbSchema([{ name: t(CommonMessages.BREADCRUMB_HOME), path: '/' }, { name: t(StatusMessages.BREADCRUMB), path: '/status' }])]}
    />
    <div className="page-wrapper"><div className="static-page">
      <h1>{t(StatusMessages.PAGE_TITLE)}</h1>
      <p className="page-subtitle">{t(StatusMessages.PAGE_SUBTITLE)}</p>

      <h2>{t(StatusMessages.NOT_AUTOMATED)}</h2>
      <p>{t(StatusMessages.NOT_AUTOMATED_BODY)}</p>

      <h2>{t(StatusMessages.SERVICES_HEADING)}</h2>
      <ul>
        <li>{t(StatusMessages.REST_API)}</li>
        <li>{t(StatusMessages.TRANSLATION_PIPELINE)}</li>
        <li>{t(StatusMessages.WEB_DASHBOARD)}</li>
        <li>{t(StatusMessages.AUTHENTICATION)}</li>
        <li>{t(StatusMessages.BILLING)}</li>
      </ul>

      <h2>{t(StatusMessages.INCIDENTS_HEADING)}</h2>
      <p>{t(StatusMessages.NO_INCIDENTS)}</p>

      <h2>{t(StatusMessages.REPORT_HEADING)}</h2>
      <p>
        <Trans i18nKey={StatusMessages.REPORT_TEXT}>
          If you're experiencing problems, please contact <a href="mailto:support@localingos.com">support@localingos.com</a>.
        </Trans>
      </p>
    </div>
    <Footer />
    </div>
    </>
  );
};
